import ImagesDiscoverSpiritoryAmericanWhiskyWebp from '@/public/images/discover-spiritory/american-whisky.webp';
import ImagesDiscoverSpiritoryCanadianWhiskyWebp from '@/public/images/discover-spiritory/canadian-whisky.webp';
import ImagesDiscoverSpiritoryIndianWhiskyWebp from '@/public/images/discover-spiritory/indian-whisky.webp';
import ImagesDiscoverSpiritoryIrishWhiskyWebp from '@/public/images/discover-spiritory/irish-whisky.webp';
import ImagesDiscoverSpiritoryJapaneseWhiskyWebp from '@/public/images/discover-spiritory/japanese-whisky.webp';

export {
  ImagesDiscoverSpiritoryAmericanWhiskyWebp,
  ImagesDiscoverSpiritoryCanadianWhiskyWebp,
  ImagesDiscoverSpiritoryIndianWhiskyWebp,
  ImagesDiscoverSpiritoryIrishWhiskyWebp,
  ImagesDiscoverSpiritoryJapaneseWhiskyWebp,
};
